import { useEffect, useRef } from "react";

export function useInterval(callback: () => void, timeout: number): void {
  const intervalFunction = useRef<() => void>();

  useEffect(
    () => intervalFunction.current = callback,
    [callback],
  );

  useEffect(
    // run the callback instantly
    () => {
      callback();
    },
    [callback],
  );

  // run code every timeout
  useEffect(
    () => {
      const interval = setInterval(() => {
        if (intervalFunction.current) {
          intervalFunction.current();
        }
      }, timeout);

      return () => clearInterval(interval);
    },
    [timeout],
  );
}
